import { useEffect } from 'react'
import { useRendererModal } from '@healthnz-prm/fhir-engine-renderer'

export function ModalManager(): null {
  const { openModal } = useRendererModal()

  useEffect(() => {
    const openModalEventHandler = (e: CustomEvent<string>) => {
      openModal(e.detail)
    }

    document.addEventListener('open-modal', openModalEventHandler)

    return () =>
      document.removeEventListener('open-modal', openModalEventHandler)
  }, [openModal])

  return null
}
